import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { loadAdSense, loadGoogleAnalytics, trackPageView } from '../../lib/thirdparty'

/**
 * Loads AdSense and Analytics once, and reports SPA navigations to GA.
 *
 * Rendered inside the router so it can see route changes. Each loader is a
 * no-op when its env id is unset, so this is safe to always mount.
 */
export default function ThirdPartyScripts() {
    const { pathname } = useLocation()
    const firstRender = useRef(true)

    useEffect(() => {
        loadAdSense()
        loadGoogleAnalytics()
    }, [])

    useEffect(() => {
        // gtag('config') already counts the initial page; only report the
        // navigations after it, or the first view is double counted
        if (firstRender.current) {
            firstRender.current = false
            return
        }
        trackPageView(pathname)
    }, [pathname])

    return null
}
